import { useStore } from "@/store/AppStore";
import { PageHeader, Panel } from "@/components/kit";
import { FeedbackItem } from "@/components/Lists";
import { FeedbackForm } from "@/components/Forms";
import { TeamPerformance } from "@/components/TeamPerformance";
import { teamOf, nameMap } from "@/lib/selectors";
import { PROFILES } from "@/data/mock";

export default function OwnerFeedback() {
  const { state, addFeedback } = useStore();
  const { companyId, name } = PROFILES.empresaria;
  const list = state.feedbacks.filter((f) => f.companyId === companyId);
  const names = nameMap(state);
  return (
    <div data-testid="owner-feedback-page">
      <PageHeader eyebrow="Pessoas" title="Feedback" subtitle="Reconheça conquistas e oriente o desenvolvimento das colaboradoras." />
      <h2 className="mb-4 font-display text-lg font-semibold">Desempenho do mês</h2>
      <div className="mb-8"><TeamPerformance companyId={companyId} /></div>
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <Panel title="Novo feedback" testId="feedback-form-panel"><FeedbackForm companyId={companyId} people={teamOf(state, companyId)} from={name} onSubmit={addFeedback} /></Panel>
        <div className="space-y-4 lg:col-span-2" data-testid="feedback-list">
          {list.map((fb) => <FeedbackItem key={fb.id} fb={fb} toName={names[fb.collaboratorId]} />)}
        </div>
      </div>
    </div>
  );
}
